import React, { Component } from 'react';
import { Form, FormGroup, FormFeedback, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';

const PAST_HELP = `
  <div>
    <p><strong>Purpose:</strong> Past access methods are those that the client has used or tried in the past but does not use currently.  
    For example, if a client has complex needs, other AT teams may have already tried a variety of access methods, with varied results.  
    </p>
    <p>If the client has a long history with alternative access, you don’t necessarily need to include every single past access method.  
    But it can be useful to understand things that have been tried and were not a good fit.  
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  methodName: PropTypes.string, //TODO add other props eventually
  onChangeMethodName: PropTypes.func.isRequired,
  methodNotes: PropTypes.string, //TODO add other props eventually
  onChangeMethodNotes: PropTypes.func.isRequired,
  methodNameError: PropTypes.string,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  methodName: '',
  methodNotes: '',
  methodNameError: ''
};

//content sub-component with unique content for this page
class PastMethodEntryForm extends Component {
  constructor(props){
    super(props);
  }

  //Render the form for entering past method info.
  //Calls the setter that's passed in by the parent, when user types.
  //That setter changes the state of the method vars in the parent, 
  //which triggers a new render of the view.
  render(){
    const methodName = this.props.methodName;
    const onChangeMethodName = this.props.onChangeMethodName;
    const methodNameError = this.props.methodNameError;
    const methodNotes = this.props.methodNotes;
    const onChangeMethodNotes = this.props.onChangeMethodNotes;
    const onSubmit = this.props.onSubmit;

    return(
    <>
    {/* TODO Resolve. currently supports hitting Enter to submit (Continue) 
    https://ux.stackexchange.com/questions/130603/which-is-best-for-an-enter-note-field-an-enter-button-or-hitting-the-return-k
    Based on traditions of user interfaces, most users probably expect to press Enter OR 
    click a Save button to enter text in a field. 
    Giving both options often makes the most sense. 
    On the other hand, if saving the text also sends you to another screen, 
    then you want to prevent accidental actions, probably by not allowing Enter, 
    and by labeling the button "Save and Close" or "Save and Exit" or similar.
    */}
    <Form onSubmit={onSubmit}>
      <FormGroup>
        <Label for="method-name">
          Name of past method:
        </Label>
        <Input
          id="method-name"
          value={methodName}
          onChange={onChangeMethodName}
          name="method-name"
          type="text"
          invalid={methodNameError !== ''}
        />
        <FormFeedback>{methodNameError}</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="method-notes">
          Why is this method no longer in use?
        </Label>
        <Input
          id="method-notes"
          value={methodNotes}
          onChange={onChangeMethodNotes}
          name="method-notes"
          placeholder="briefly describe past experiences with this method"
          type="textarea"
        />
      </FormGroup>
      {' '}
    </Form>
    </>
  );
}
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoHistoryPastMethodEntry(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const methodName = props.methodName;
  const onChangeMethodName = props.onChangeMethodName;
  const methodNameError = props.methodNameError;
  const methodNotes = props.methodNotes;
  const onChangeMethodNotes = props.onChangeMethodNotes;
  const onContinue = props.onContinue;

  // console.log("rendering PastMethodEntry: " + methodNotes);

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",
    title: `Tell us about this access method`,
    subTitle: `This should be a method that ${firstName} tried previously but no longer uses.`,
    learnMore: {linkText: "Learn More about what we mean by a past access method and why it matters",
                title: "Past Access Methods",
                content: PAST_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true,
    backName: 'Cancel',
    continueName: 'Done'
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <PastMethodEntryForm 
          firstName={firstName} 
          pronouns={pronouns}
          methodName={methodName} 
          onChangeMethodName={onChangeMethodName}
          methodNameError={methodNameError}
          methodNotes={methodNotes} 
          onChangeMethodNotes={onChangeMethodNotes}
          onSubmit={onContinue}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoHistoryPastMethodEntry.propTypes = propTypes;
GatherInfoHistoryPastMethodEntry.defaultProps = defaultProps;

export default GatherInfoHistoryPastMethodEntry;